import React, { ReactNode }                         from "react";
import { DndProvider }                              from "react-dnd";
import TouchBackend                                 from "react-dnd-touch-backend/";
import { connect }                                  from "react-redux";
import MenuType                                     from "../../../domain/menu/MenuType";
import RecordTemplateRepository                     from "../../../domain/record/template/RecordTemplateRepository";
import { ResKaState }                               from "../../../index";
import RecordTemplateDataSource
                                                    from "../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import RecordTemplateForm                           from "../../components/record/template/RecordTemplateForm";
import RecordTemplateSaveButton                     from "../../components/record/template/RecordTemplateSaveButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  recordTemplateRepository: RecordTemplateRepository;
}

class RecordTemplateRegisterContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "記録テンプレート作成",
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.recordTemplateRepository.initialize();
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "記録テンプレート一覧",
                path: "/record/templates"
              },
              {
                title: "記録テンプレート作成",
                path: "/record/template/register"
              }
            ]
          }/>
        </TopSection>

        <TopSection>
          <RecordTemplateSaveButton/>
          <BackHistoryButton path="/record/templates"/>
        </TopSection>

        <DndProvider backend={ TouchBackend } options={ {enableMouseEvents: true} }>
          <RecordTemplateForm/>
        </DndProvider>

        <BottomSection>
          <RecordTemplateSaveButton/>
          <BackHistoryButton path="/record/templates"/>
        </BottomSection>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

const mapDispatchToProps = (dispatch) => ({
  recordTemplateRepository: new RecordTemplateDataSource(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordTemplateRegisterContainer);
